import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {ContentObj} from '../../../generated/generated-core.model';

@Injectable({
    providedIn: 'root'
})
export class MxDownloadService {

    private getFileNameFromHeader(contentDisposition: string): string {
        if (contentDisposition) {
            return contentDisposition.match(/filename=(.+)/)[1];
        } else {
            return '';
        }
    }

    private getFileNameFromHeaders(headers: HttpHeaders): string {
        let contentDisposition = headers.get('content-disposition');
        return this.getFileNameFromHeader(contentDisposition);
    }

    private saveAs(data: Blob, filename: string): void {
        const saver: HTMLAnchorElement = <HTMLAnchorElement>document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
        saver.href = URL.createObjectURL(data);
        saver.target = '_blank';
        saver.download = filename;
        saver.rel = 'noopener'
        saver.dispatchEvent(new MouseEvent("click"));
    }

    public saveContentAsFile(contentObj: ContentObj): void {
        let blob: Blob = this.b64toBlob(contentObj.data, contentObj.type);
        this.saveAs(blob, contentObj.name);
    }

    public saveResponseAsFile(response: HttpResponse<Blob>, contentType?: string,
                              fileName?: string, fileType?: string): Observable<HttpResponse<Blob>> {
        let blob: Blob = new Blob([response.body], {type: contentType});
        this.saveAs(blob, fileName || this.getFileNameFromHeaders(response.headers) + (fileType || ''));
        return of(response);
    }

    public saveErrorAsFile(error: HttpErrorResponse,
                           contentType?: string, fileName?: string): Observable<HttpErrorResponse> {
        let blob: Blob = new Blob([error.error], {type: contentType});
        this.saveAs(blob, fileName || this.getFileNameFromHeaders(error.headers));
        return of(error);
    }

    private b64toBlob(b64Data: string, contentType: string, sliceSize: number = 512): Blob {
        contentType = 'application/' + contentType || '';

        let byteCharacters = atob(b64Data);
        let byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);

            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            let byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        let blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

}
